"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentHistory = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * CommentHistory.tsx
 * Author: fwunderlich
 * Date: 13.02.2024
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_1 = require("react");
const moment_1 = __importDefault(require("moment"));
const react_i18next_1 = require("react-i18next");
const utils_1 = require("primereact/utils");
const CommentHistory = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)(['common', 'stammdaten']);
    const style = {
        comment: {
            backgroundColor: 'white',
            color: 'black',
            border: '1px solid black',
            borderRadius: '7px',
            padding: '10px'
        }
    };
    const colors = [
        '#e6e6fa5F',
        '#c6e2ff5F',
        '#b0e0e65F',
        '#d3ffce5F',
        '#edc3c35F',
        '#fad0b95F',
        '#f4f2c35F',
    ];
    (0, react_1.useEffect)(() => {
        let temp = [];
        for (let i = 0; i < props.comments.length; i++) {
            let item = props.comments[i];
            if (temp.indexOf(item.ersteller) < 0) {
                temp.push(item.ersteller);
            }
            if (colors.length > temp.indexOf(item.ersteller)) {
                item.color = colors[temp.indexOf(item.ersteller)];
            }
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'p-3', style: { maxHeight: '200px', overflow: 'auto' } }, { children: props.comments.map((item, index) => {
            return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, utils_1.classNames)('p-2 flex', index > 0 ? 'mt-4' : ''), style: { borderRadius: '7px', backgroundColor: item.color } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'font-bold mr-3' }, { children: item.type })), (0, jsx_runtime_1.jsx)("div", { children: (0, moment_1.default)(item.zeitstempel).format(t('datetimeformat')) + (` (${item.ersteller})`) })] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: style.comment }, { children: (0, jsx_runtime_1.jsx)("i", { children: item.kommentar }) }))] });
        }) })));
};
exports.CommentHistory = CommentHistory;
